import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

class DashboardItem extends Component {

    render() {
        var self = this

        var footer = null
        if (self.props.selected) {
            footer = (
                <Link to={self.props.selected}>
                    <div className="panel-footer">
                        <span className="pull-left">Ver detalles</span>
                        <span className="pull-right"><i className="fa fa-arrow-circle-right"></i></span>
                        <div className="clearfix"></div>
                    </div>
                </Link>
            )
        } else {
            footer = (
                <div className="panel-footer">
                    <span className="pull-left">&nbsp;</span>
                    <span className="pull-right">&nbsp;</span>
                    <div className="clearfix"></div>
                </div>
            )
        }

        var cols = 'col-xs-12 col-sm-4'

        if (self.props.cols) {
            cols = `col-xs-12 col-sm-${self.props.cols}`
        }

        return (
            <div className={cols}>
                <div className={ 'panel panel-' + self.props.color }>
                    <div className="panel-heading">
                        <div className="row">
                            <div className="col-xs-3">
                                <i className={ self.props.icon + ' fa fa-5x' }></i>
                            </div>
                            <div className="col-xs-9 text-right">
                                <div className="huge">{ parseInt(self.props.count) === self.props.count ? self.props.count : self.props.count.toFixed(2) }</div>
                                <div>{ self.props.name }</div>
                            </div>
                        </div>
                    </div>
                    { footer }
                </div>
            </div>
        )
    }
}

DashboardItem.propTypes = {
    count: PropTypes.number,
    icon: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    selected: PropTypes.string,
    cols: PropTypes.number
}

DashboardItem.defaultProps = {
    count: 0
}

export default DashboardItem



// WEBPACK FOOTER //
// ./components/common/DashboardItem/index.js